import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useConfigurator = create(
  persist(
    (set) => ({
      selectedColor: { name: 'Natural White', hex: '#F5F5F0', category: 'ALL' },
      selectedSize: null,
      selectedSole: 'white', // 'white' or 'black'
      selectedLace: 'same', // 'same' (as body), 'white', 'black'
      rotation: 0,
      isRotating: false,
      
      setSelectedColor: (color) => set({ selectedColor: color }),
      setSelectedSize: (size) => set({ selectedSize: size }),
      setSelectedSole: (sole) => set({ selectedSole: sole }),
      setSelectedLace: (lace) => set({ selectedLace: lace }),
      setRotation: (rotation) => set({ rotation }),
      setIsRotating: (isRotating) => set({ isRotating }),
      
      getConfigJSON: () => {
        const state = useConfigurator.getState();
        return {
          color: state.selectedColor,
          size: state.selectedSize,
          sole: state.selectedSole,
          lace: state.selectedLace,
          modelId: 'i3dcdemox1-runner-v1'
        };
      }
    }),
    {
      name: 'i3dcdemox1-configurator-storage',
      partialize: (state) => ({
        selectedColor: state.selectedColor,
        selectedSize: state.selectedSize,
        selectedSole: state.selectedSole,
        selectedLace: state.selectedLace
      })
    }
  )
);

export default useConfigurator;
